import { RecognizeEmailStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import MailIcon from "@redotech/redo-icons/mail-01_filled.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface RecognizeEmailNodeData {
  deleteElements: (id: string) => void;
  step: PartialWithRequiredType<RecognizeEmailStep>;
}

export function RecognizeEmailNode(data: {
  id: string;
  data: RecognizeEmailNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();
  const recipientCount = data.data.step.recipientUserIds?.length ?? 0;

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        icon={<RedoFeaturedIcon color="success" Icon={MailIcon} size="xs" />}
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title={t("Action")}
      >
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text>Email {recipientCount} team members</Text>
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
